// src/scenes/dashboard/config/mappers.js

// =======================
// Helpers FSC V3 (tuyos)
// =======================

// ✅ Ordena por fecha DESC
export const sortDescByFecha = (arr) =>
  [...(arr ?? [])].sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

// ✅ Normaliza keys: trim
export const normalizeKeysTrim = (row) => {
  const cleaned = {};
  for (const key in (row ?? {})) cleaned[String(key).trim()] = row[key];
  return cleaned;
};


// ✅ Formatea a UTC "YYYY-MM-DD HH:mm:ss"
export const formatUTC = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;

  return (
    `${d.getUTCFullYear()}-` +
    `${String(d.getUTCMonth() + 1).padStart(2, "0")}-` +
    `${String(d.getUTCDate()).padStart(2, "0")} ` +
    `${String(d.getUTCHours()).padStart(2, "0")}:` +
    `${String(d.getUTCMinutes()).padStart(2, "0")}:` +
    `${String(d.getUTCSeconds()).padStart(2, "0")}`
  );
};

// =======================
// Helpers FSC V3
// =======================
export const norm = (s) =>
  String(s ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const normalizeKeys = (row) => {
  const out = {};
  for (const k in (row ?? {})) out[norm(k)] = row[k];
  return out;
};

export const pick = (obj, keys) => {
  for (const k of keys) {
    const v = obj?.[norm(k)];
    if (v !== undefined && v !== null && String(v).trim() !== "") return v;
  }
  return null;
};


// =======================
// MAPPERS
// =======================

const mapOptichiller2Comp = (data, idEquipo) =>
  sortDescByFecha(
    (data ?? [])
      .map((row, index) => {
        const r = normalizeKeys(row);

        const fecha = formatUTC(pick(r, ["Fecha"]));
        if (!fecha) return null;

        return {
          id: index + 1,
          numeroEquipo:
            pick(r, ["Número de Equipo", "Numero de Equipo"]) || idEquipo,
          fecha,

          presionSuccionComp1: pick(r, [
            "Pres. Succión Compresor 1",
            "Pres. Succion Compresor 1",
            "Presión Succión Compresor 1",
            "Presion Succion Compresor 1",
            "Presión Succión Comp. 1",
            "Presion Succion Comp. 1",
            "Presion Succion Comp 1",
            "Pres. Succión Comp 1",
            "Pres. Succion Comp 1",
          ]),

          presionSuccionComp2: pick(r, [
            "Pres. Succión Compresor 2",
            "Pres. Succion Compresor 2",
            "Presión Succión Compresor 2",
            "Presion Succion Compresor 2",
            "Presión Succión Comp. 2",
            "Presion Succion Comp. 2",
            "Presion Succion Comp 2",
            "Pres. Succión Comp 2",
            "Pres. Succion Comp 2",
          ]),

          tempSuccionComp1: pick(r, [
            "Temp. Succion Comp 1",
            "Temp. Succión Comp 1",
            "Temp. Succion Comp. 1",
            "Temp. Succión Comp. 1",
            "Temp Succion Comp 1",
          ]),

          tempSuccionComp2: pick(r, [
            "Temp. Succion Comp 2",
            "Temp. Succión Comp 2",
            "Temp. Succion Comp. 2",
            "Temp. Succión Comp. 2",
            "Temp Succion Comp 2",
          ]),

          tempProcesoEntrada: pick(r, ["Temp. Proceso Entrada"]),
          tempProcesoSalida: pick(r, ["Temp. Proceso Salida"]),
          tempTorreEntrada: pick(r, ["Temp. Torre Entrada"]),
          tempTorreSalida: pick(r, ["Temp. Torre Salida"]),

          tempDescargaComp1: pick(r, [
            "Temp. Descarga Compresor 1",
            "Temp. Descarga Comp. 1",
            "Temp. Descarga Comp 1",
          ]),

          tempDescargaComp2: pick(r, [
            "Temp. Descarga Compresor 2",
            "Temp. Descarga Comp. 2",
            "Temp. Descarga Comp 2",
          ]),

          presionDescargaComp1: pick(r, [
            "Pres. Descarga Compresor 1",
            "Pres. Descarga Comp 1",
            "Presión Descarga Compresor 1",
            "Presion Descarga Compresor 1",
            "Presión Descarga Comp. 1",
            "Presion Descarga Comp. 1",
            "Presion Descarga Comp 1",
          ]),

          presionDescargaComp2: pick(r, [
            "Pres. Descarga Compresor 2",
            "Pres. Descarga Comp 2",
            "Presión Descarga Compresor 2",
            "Presion Descarga Compresor 2",
            "Presión Descarga Comp. 2",
            "Presion Descarga Comp. 2",
            "Presion Descarga Comp 2",
          ]),

           porcentajeCargaComp1: pick(r, [
            "Porcentaje Carga Comp 1",
            "Porcentaje Carga Compresor 1",
            "Porc Carga C1",
            "Porc_Carga_C1",
            "Carga Comp 1",
          ]),

          porcentajeCargaComp2: pick(r, [
            "Porcentaje Carga Comp 2",
            "Porcentaje Carga Compresor 2",
            "Porc Carga C2",
            "Porc_Carga_C2",
            "Carga Comp 2",
          ]),
          sobrecalentamientoComp1: pick(r, [
            "Sobrecalentamiento Comp 1",
            "Sobrecalentamiento Cmp 1",
          ]),

          sobrecalentamientoComp2: pick(r, [
            "Sobrecalentamiento Comp 2",
            "Sobrecalentamiento Cmp 2",
          ]),
          encendidoComp1: pick(r, ["Encendido Compresor 1"]),
          encendidoComp2: pick(r, ["Encendido Compresor 2"]),
        };
      })
      .filter(Boolean)
  );

const mapCentrifuga = (data, idEquipo) =>
sortDescByFecha(
  (data ?? [])
    .map((row, index) => {
      const r = normalizeKeysTrim(row);
      const fecha = formatUTC(r["Fecha"]);
      if (!fecha) return null;

      return {
        id: index + 1,
        numeroEquipo: r["Número de Equipo"] || idEquipo,
        fecha,

        tempProcesoEntrada: r["Temp Proceso Entrada"],
        tempProcesoSalida: r["Temp Proceso Salida"],
        tempAguaTorreEntrada: r["Temp Agua Torre Entrada"],
        tempAguaTorreSalida: r["Temp Agua Torre Salida"],
        presAbsolutaSuccion: r["Pres Absoluta Succión"],
        presAbsolutaDescarga: r["Pres Absoluta Descarga"],
        tempDescarga: r["Temp Descarga"],

        posicionSlideValve:
          r["Posición Slide-Valve"] ??
          r["Posicion Slide-Valve"] ??
          r["Posición Slide Valve"] ??
          r["Posicion Slide Valve"],
        
        encendidoCompresor: r["Encendido Compresor"],
      };
    })
    .filter(Boolean)
);


const mapCoTherm2Comp = (data, idEquipo) =>
sortDescByFecha(
  (data ?? [])
    .map((row, index) => {
      const r = normalizeKeysTrim(row);
      const fecha = formatUTC(r["Fecha"]);
      if (!fecha) return null;

      return {
        id: index + 1,
        numeroEquipo: r["Número de Equipo"] || idEquipo,
        fecha,

        presSuccionComp1: r["Pres. Succion Comp 1"],
        presSuccionComp2: r["Pres. Succion Comp 2"],
        presionDescargaComp1: r["Presion Descarga Comp 1"],
        presionDescargaComp2: r["Presion Descarga Comp 2"],
        tempProcesoEntrada: r["Temp. Proceso Entrada"],
        tempProcesoSalida: r["Temp. Proceso Salida"],
        tempEvapSalidaC1: r["Temp. Evap Salida C1"],
        tempEvapSalidaC2: r["Temp. Evap Salida C2"],
        tempDescargaComp1: r["Temp. Descarga Comp 1"],
        tempDescargaComp2: r["Temp. Descarga Comp 2"],

        porcentajeCargaComp1:
          r["Porcentaje Carga Comp 1"] ??
          r["Porcentaje Carga Compresor 1"] ??
          r["Porc Carga C1"] ??
          r["Porc_Carga_C1"] ??
          r["Carga Comp 1"],

        porcentajeCargaComp2:
          r["Porcentaje Carga Comp 2"] ??
          r["Porcentaje Carga Compresor 2"] ??
          r["Porc Carga C2"] ??
          r["Porc_Carga_C2"] ??
          r["Carga Comp 2"],

        sobrecalentamientoComp1: r["Sobrecalentamiento Comp 1"],
        sobrecalentamientoComp2: r["Sobrecalentamiento Comp 2"],
        encendidoComp1: r["Encendido Compresor 1"],
        encendidoComp2: r["Encendido Compresor 2"],
      };
    })
    .filter(Boolean)
);

const mapCoTherm4Comp = (data, idEquipo) =>
sortDescByFecha(
  (data ?? [])
    .map((row, index) => {
      const r = normalizeKeysTrim(row);
      const fecha = formatUTC(r["Fecha"]);
      if (!fecha) return null;

      return {
        id: index + 1,
        numeroEquipo: r["Número de Equipo"] || idEquipo,
        fecha,

        tempHeladaEntrada: r["Temp. Helada Entrada"],
        tempHeladaSalida: r["Temp. Helada Salida"],
        tempCondEntrada: r["Temp. Condensación Entrada"],
        tempCondSalida: r["Temp. Condensación Salida"],

        presSuccionComp1: r["Pres. Succion Comp 1"],
        presSuccionComp2: r["Pres. Succion Comp 2"],
        presSuccionComp3: r["Pres. Succion Comp 3"],
        presSuccionComp4: r["Pres. Succion Comp 4"],

        presionDescargaComp1: r["Presion Descarga Comp 1"],
        presionDescargaComp2: r["Presion Descarga Comp 2"],
        presionDescargaComp3: r["Presion Descarga Comp 3"],
        presionDescargaComp4: r["Presion Descarga Comp 4"],

        presionDifAceiteComp1: r["Presion Dif. Aceite Comp 1"],
        presionDifAceiteComp2: r["Presion Dif. Aceite Comp 2"],
        presionDifAceiteComp3: r["Presion Dif. Aceite Comp 3"],
        presionDifAceiteComp4: r["Presion Dif. Aceite Comp 4"],
      };
    })
    .filter(Boolean)
);

const mapCoTherm4Comp2cc = (data, idEquipo) =>
sortDescByFecha(
  (data ?? [])
    .map((row, index) => {
      const r = normalizeKeysTrim(row);
      const fecha = formatUTC(r["Fecha"]);
      if (!fecha) return null;

      return {
        id: index + 1,
        numeroEquipo: r["Número de Equipo"] || idEquipo,
        fecha,

          tempHeladaEntrada: r["Temp. Helada Entrada"],
          tempHeladaSalida: r["Temp. Helada Salida"],
          tempCondEntrada: r["Temp. Condensación Entrada"],
          tempCondSalida: r["Temp. Condensación Salida"],
          tempCondSecEntrada: r["Temp. Condensación Sec Entrada"],
          tempCondSecSalida: r["Temp. Condensación Sec Salida"],

          presSuccionComp1: r["Pres. Succion Comp 1"],
          presSuccionComp2: r["Pres. Succion Comp 2"],
          presSuccionComp3: r["Pres. Succion Comp 3"],
          presSuccionComp4: r["Pres. Succion Comp 4"],

          presionDescargaComp1: r["Presion Descarga Comp 1"],
          presionDescargaComp2: r["Presion Descarga Comp 2"],
          presionDescargaComp3: r["Presion Descarga Comp 3"],
          presionDescargaComp4: r["Presion Descarga Comp 4"],

          presionDifAceiteComp1: r["Presion Dif. Aceite Comp 1"],
          presionDifAceiteComp2: r["Presion Dif. Aceite Comp 2"],
          presionDifAceiteComp3: r["Presion Dif. Aceite Comp 3"],
          presionDifAceiteComp4: r["Presion Dif. Aceite Comp 4"],
      };
    })
    .filter(Boolean)
);

const mapEzchiller2Compct6 = (data, idEquipo) =>
sortDescByFecha(
  (data ?? [])
    .map((row, index) => {
      const r = normalizeKeysTrim(row);
      const fecha = formatUTC(r["Fecha"]);
      if (!fecha) return null;

      return {
        id: index + 1,
        numeroEquipo: r["Número de Equipo"] || idEquipo,
        fecha,

          presionSuccionComp1: r["Pres. Succion Comp 1"],
          presionSuccionComp2: r["Pres. Succion Comp 2"],
          presionDescargaComp1: r["Presion Descarga Comp 1"],
          presionDescargaComp2: r["Presion Descarga Comp 2"],

          tempProcesoEntrada: r["Temp. Proceso Entrada"],
          tempProcesoSalida: r["Temp. Proceso Salida"],
          tempRefrCondensado1: r["Temp. Condensación Entrada"],
          tempRefrCondensado2: r["Temp. Condensación Salida"],
          tempDescargaComp1: r["Temp. Descarga Comp 1"],
          tempDescargaComp2: r["Temp. Descarga Comp 2"],

          porcentajeCargaComp1:
            r["Porcentaje Carga Comp 1"] ??
            r["Porcentaje Carga Compresor 1"] ??
            r["Porc Carga C1"] ??
            r["Porc_Carga_C1"] ??
            r["Carga Comp 1"],

          porcentajeCargaComp2:
            r["Porcentaje Carga Comp 2"] ??
            r["Porcentaje Carga Compresor 2"] ??
            r["Porc Carga C2"] ??
            r["Porc_Carga_C2"] ??
            r["Carga Comp 2"],

          sobrecalentamientoComp1: r["Sobrecalentamiento Comp 1"],
          sobrecalentamientoComp2: r["Sobrecalentamiento Comp 2"],

          encendidoComp1: r["Encendido Compresor 1"],
          encendidoComp2: r["Encendido Compresor 2"],
      };
    })
    .filter(Boolean)
);

const mapFSC = (data, idEquipo) =>
sortDescByFecha(
  (data ?? [])
    .map((row, index) => {
      const r = normalizeKeysTrim(row);
      const fecha = formatUTC(r["Fecha"]);
      if (!fecha) return null;

      return {
        id: index + 1,
        numeroEquipo: r["Número de Equipo"] || idEquipo,
        fecha,

          tempProcesoEntrada: r["Temp. Proceso Entrada"],
          tempProcesoSalida: r["Temp. Proceso Salida"],

          m1TempEvapSalida: r["M1 Temp. Evap Salida"],
          m1TempDescarga: r["M1 Temp. Descarga"],
          m1PresSuccion: r["M1 Pres. Succión"],
          m1PresDescarga: r["M1 Pres. Descarga"],
          m1NumeroEquipo: r["M1 Número de Equipo"],
          m1CondicionActual: r["M1 Condición Actual del Compresor"],

          m2TempEvapSalida: r["M2 Temp. Evap Salida"],
          m2TempDescarga: r["M2 Temp. Descarga"],
          m2PresSuccion: r["M2 Pres. Succión"],
          m2PresDescarga: r["M2 Pres. Descarga"],
          m2NumeroEquipo: r["M2 Número de Equipo"],
          m2CondicionActual: r["M2 Condición Actual del Compresor"],

          m3TempEvapSalida: r["M3 Temp. Evap Salida"],
          m3TempDescarga: r["M3 Temp. Descarga"],
          m3PresSuccion: r["M3 Pres. Succión"],
          m3PresDescarga: r["M3 Pres. Descarga"],
          m3NumeroEquipo: r["M3 Número de Equipo"],
          m3CondicionActual: r["M3 Condición Actual del Compresor"],

          m4TempEvapSalida: r["M4 Temp. Evap Salida"],
          m4TempDescarga: r["M4 Temp. Descarga"],
          m4PresSuccion: r["M4 Pres. Succión"],
          m4PresDescarga: r["M4 Pres. Descarga"],
          m4NumeroEquipo: r["M4 Número de Equipo"],
          m4CondicionActual: r["M4 Condición Actual del Compresor"],

          m5TempEvapSalida: r["M5 Temp. Evap Salida"],
          m5TempDescarga: r["M5 Temp. Descarga"],
          m5PresSuccion: r["M5 Pres. Succión"],
          m5PresDescarga: r["M5 Pres. Descarga"],
          m5NumeroEquipo: r["M5 Número de Equipo"],
          m5CondicionActual: r["M5 Condición Actual del Compresor"],

          m6TempEvapSalida: r["M6 Temp. Evap Salida"],
          m6TempDescarga: r["M6 Temp. Descarga"],
          m6PresSuccion: r["M6 Pres. Succión"],
          m6PresDescarga: r["M6 Pres. Descarga"],
          m6NumeroEquipo: r["M6 Número de Equipo"],
          m6CondicionActual: r["M6 Condición Actual del Compresor"],

          m7TempEvapSalida: r["M7 Temp. Evap Salida"],
          m7TempDescarga: r["M7 Temp. Descarga"],
          m7PresSuccion: r["M7 Pres. Succión"],
          m7PresDescarga: r["M7 Pres. Descarga"],
          m7NumeroEquipo: r["M7 Número de Equipo"],
          m7CondicionActual: r["M7 Condición Actual del Compresor"],

          m8TempEvapSalida: r["M8 Temp. Evap Salida"],
          m8TempDescarga: r["M8 Temp. Descarga"],
          m8PresSuccion: r["M8 Pres. Succión"],
          m8PresDescarga: r["M8 Pres. Descarga"],
          m8NumeroEquipo: r["M8 Número de Equipo"],
          m8CondicionActual: r["M8 Condición Actual del Compresor"],

          m9TempEvapSalida: r["M9 Temp. Evap Salida"],
          m9TempDescarga: r["M9 Temp. Descarga"],
          m9PresSuccion: r["M9 Pres. Succión"],
          m9PresDescarga: r["M9 Pres. Descarga"],
          m9NumeroEquipo: r["M9 Número de Equipo"],
          m9CondicionActual: r["M9 Condición Actual del Compresor"],

          m10TempEvapSalida: r["M10 Temp. Evap Salida"],
          m10TempDescarga: r["M10 Temp. Descarga"],
          m10PresSuccion: r["M10 Pres. Succión"],
          m10PresDescarga: r["M10 Pres. Descarga"],
          m10NumeroEquipo: r["M10 Número de Equipo"],
          m10CondicionActual: r["M10 Condición Actual del Compresor"],
      };
    })
    .filter(Boolean)
);

const mapFSCUNICO = (data, idEquipo) =>
  sortDescByFecha(
    (data ?? [])
      .map((row, index) => {
        const r = normalizeKeysTrim(row);
        const fecha = formatUTC(r["Fecha"]);
        if (!fecha) return null;

        return {
          id: index + 1,
          numeroEquipo: r["Número de Equipo"] || idEquipo,
          fecha,

          presSuccionC1:
            r["Pres. Succion Comp 1"] ?? r["Pres. Succión Comp 1"],
          presSuccionC2:
            r["Pres. Succion Comp 2"] ?? r["Pres. Succión Comp 2"],

          presDescargaC1: r["Pres. Descarga Comp 1"],
          presDescargaC2: r["Pres. Descarga Comp 2"],

          superheatC1: r["Superheat Comp 1"],
          superheatC2: r["Superheat Comp 2"],

          tempEvapEnt: r["Temp. Evap Entrada"],
          tempEvapSal: r["Temp. Evap Salida"],

          tempSuccionC1:
            r["Temp. Succion Comp 1"] ?? r["Temp. Succión Comp 1"],
          tempSuccionC2:
            r["Temp. Succion Comp 2"] ?? r["Temp. Succión Comp 2"],

          estadoComp1: r["Estado Comp 1"],
          estadoComp2: r["Estado Comp 2"],

          encendidoComp1: r["Encendido Comp 1"],
          encendidoComp2: r["Encendido Comp 2"],

          condicionActualComp1: r["Cond. Actual Comp 1"],
          condicionActualComp2: r["Cond. Actual Comp 2"],

          porcentajeCargaComp1: r["Porcentaje Carga Comp 1"],
          porcentajeCargaComp2: r["Porcentaje Carga Comp 2"],
          porcentajeCargaTotal: r["Porcentaje Carga Total"],
        };
      })
      .filter(Boolean)
  );

const mapFSCV3 = (data, idEquipo) =>
  sortDescByFecha(
    (data ?? [])
      .map((row, index) => {
        const r = normalizeKeys(row);

        const fecha = formatUTC(
          pick(r, ["Fecha", "Date", "Datetime", "DateTime"])
        );
        if (!fecha) return null;

        const base = {
          id: index + 1,
          numeroEquipo: pick(r, ["Número de Equipo", "Numero de Equipo"]) ?? idEquipo,
          fecha,
          tempProcesoEntrada: pick(r, ["Temp. Proceso Entrada", "Temp Proceso Entrada"]),
          tempProcesoSalida: pick(r, ["Temp. Proceso Salida", "Temp Proceso Salida"]),
        };

        for (let n = 1; n <= 10; n++) {
          base[`m${n}TempEvapSalida`] = pick(r, [
            `M${n} Temp. Evap Salida`,
            `M${n} Temp Evap Salida`,
          ]);

          base[`m${n}TempEvapEntrada`] = pick(r, [
            `M${n} Temp. Evap Entrada`,
            `M${n} Temp Evap Entrada`,
          ]);

          base[`m${n}PresDescC1`] = pick(r, [
            `M${n} Pres. Descarga C1`,
            `M${n} Pres Descarga C1`,
          ]);

          base[`m${n}PresDescC2`] = pick(r, [
            `M${n} Pres. Descarga C2`,
            `M${n} Pres Descarga C2`,
          ]);

          base[`m${n}NumeroEquipo`] = pick(r, [
            `M${n} Número de Equipo`,
            `M${n} Numero de Equipo`,
          ]);

          base[`m${n}PorcentajeCargaComp1`] = pick(r, [
            `M${n} Porcentaje Carga Comp 1`,
            `M${n} Porcentaje Carga Compresor 1`,
            `M${n} Porc Carga C1`,
            `M${n} Porc_Carga_C1`,
          ]);

          base[`m${n}PorcentajeCargaComp2`] = pick(r, [
            `M${n} Porcentaje Carga Comp 2`,
            `M${n} Porcentaje Carga Compresor 2`,
            `M${n} Porc Carga C2`,
            `M${n} Porc_Carga_C2`,
          ]);
        }

        return base;
      })
      .filter(Boolean)
  );

const mapLicuador1Comp = (data, idEquipo) =>
  sortDescByFecha(
    (data ?? [])
      .map((row, index) => {
        const r = normalizeKeysTrim(row);
        const fecha = formatUTC(r["Fecha"]);
        if (!fecha) return null;

        return {
          id: index + 1,
          numeroEquipo: r["Número de Equipo"] || idEquipo,
          fecha,

          presSuccion: r["Pres. Succión"],
          presDescarga: r["Pres. Descarga"],
          tempRefrEvap: r["Temp. Refr Evap"],
          tempProcesoEntrada: r["Temp. Proceso Entrada"],
          tempProcesoSalida: r["Temp. Proceso Salida"],
          tempCondEntrada: r["Temp. Cond Entrada"],
          tempCondSalida: r["Temp. Cond Salida"],
          tempDescarga: r["Temp. Descarga"],

          porcentajeCargaComp1:
            r["Porcentaje Carga Comp 1"] ??
            r["Porcentaje Carga Compresor 1"] ??
            r["Porc Carga"] ??
            r["Carga Comp 1"],

          sobrecalentamientoComp1: r["Sobrecalentamiento Comp 1"],
          encendidoComp1: r["Encendido Compresor 1"],
        };
      })
      .filter(Boolean)
);

const mapOptichillerct6 = (data, idEquipo) =>
sortDescByFecha(
  (data ?? [])
    .map((row, index) => {
      const r = normalizeKeysTrim(row);
      const fecha = formatUTC(r["Fecha"]);
      if (!fecha) return null;

      return {
        id: index + 1,
        numeroEquipo: r["Número de Equipo"] || idEquipo,
        fecha,

          presSuccionComp1: r["Presion Succion Comp 1"] ?? r["Presión Succión Comp 1"] ?? r["Pres. Succion Comp 1"] ?? r["Pres. Succión Comp 1"],
          presSuccionComp2: r["Presion Succion Comp 2"] ?? r["Presión Succión Comp 2"] ?? r["Pres. Succion Comp 2"] ?? r["Pres. Succión Comp 2"],
          presionDescargaComp1: r["Presion Descarga Comp 1"] ?? r["Presión Descarga Comp 1"],
          presionDescargaComp2: r["Presion Descarga Comp 2"] ?? r["Presión Descarga Comp 2"],

          tempProcesoEntrada:
            r["Temp. Proceso Entrada"] ??
            r["Temp Proceso Entrada"],

          tempProcesoSalida:
            r["Temp. Proceso Salida"] ??
            r["Temp Proceso Salida"],

          tempTorreEntrada:
            r["Temp. Torre Entrada"] ??
            r["Temp Torre Entrada"] ??
            r["Temp. Agua Torre Entrada"] ??
            r["Temp Agua Torre Entrada"],

          tempTorreSalida:
            r["Temp. Torre Salida"] ??
            r["Temp Torre Salida"] ??
            r["Temp. Agua Torre Salida"] ??
            r["Temp Agua Torre Salida"],

          tempDescargaComp1: r["Temp. Descarga Compresor 1"] ?? r["Temp. Descarga Comp 1"],
          tempDescargaComp2: r["Temp. Descarga Compresor 2"] ?? r["Temp. Descarga Comp 2"],

          porcentajeCargaComp1:
            r["Porcentaje Carga Comp 1"] ??
            r["Porcentaje Carga Compresor 1"] ??
            r["Porc Carga C1"] ??
            r["Porc_Carga_C1"] ??
            r["Carga Comp 1"],

          porcentajeCargaComp2:
            r["Porcentaje Carga Comp 2"] ??
            r["Porcentaje Carga Compresor 2"] ??
            r["Porc Carga C2"] ??
            r["Porc_Carga_C2"] ??
            r["Carga Comp 2"],

          sobrecalentamientoComp1: r["Sobrecalentamiento Comp 1"],
          sobrecalentamientoComp2: r["Sobrecalentamiento Comp 2"], 
          encendidoComp1: r["Encendido Compresor 1"],
          encendidoComp2: r["Encendido Compresor 2"],
      };
    })
    .filter(Boolean)
);

const mapOptichiller1Comp = (data, idEquipo) =>
  sortDescByFecha(
    (data ?? [])
      .map((row, index) => {
        const r = normalizeKeysTrim(row);
        const fecha = formatUTC(r["Fecha"]);
        if (!fecha) return null;

        return {
          id: index + 1,
          numeroEquipo: r["Número de Equipo"] || idEquipo,
          fecha,

          presionSuccionComp1: r["Presion Succion Comp 1"],
          presionDescargaComp1: r["Presion Descarga Comp 1"],

          tempProcesoEntrada: r["Temp. Proceso Entrada"],
          tempProcesoSalida: r["Temp. Proceso Salida"],

          tempTorreEntrada: r["Temp. Torre Entrada"],
          tempTorreSalida: r["Temp. Torre Salida"],

          tempDescargaComp1: r["Temp. Descarga Compresor 1"],

          porcentajeCargaComp1: r["Porcentaje Carga Comp 1"],
          sobrecalentamientoComp1: r["Sobrecalentamiento Comp 1"],
          encendidoComp1: r["Encendido Compresor 1"],
        };
      })
      .filter(Boolean)
  );

const mapOptichiller1Compct6 = (data, idEquipo) =>
sortDescByFecha(
  (data ?? [])
    .map((row, index) => {
      const r = normalizeKeysTrim(row);
      const fecha = formatUTC(r["Fecha"]);
      if (!fecha) return null;

      return {
        id: index + 1,
        numeroEquipo: r["Número de Equipo"] || idEquipo,
        fecha,

        presSuccionComp1:
          r["Presion Succion Comp 1"] ??
          r["Presión Succión Comp 1"] ??
          r["Pres. Succion Comp 1"] ??
          r["Pres. Succión Comp 1"],

        presDescargaComp1:
          r["Presion Descarga Comp 1"] ??
          r["Presión Descarga Comp 1"] ??
          r["Pres. Descarga Comp 1"],

        tempProcesoEntrada:
          r["Temp. Proceso Entrada"] ??
          r["Temp Proceso Entrada"],

        tempProcesoSalida:
          r["Temp. Proceso Salida"] ??
          r["Temp Proceso Salida"],

        tempTorreEntrada:
          r["Temp. Torre Entrada"] ??
          r["Temp Torre Entrada"],

        tempTorreSalida:
          r["Temp. Torre Salida"] ??
          r["Temp Torre Salida"],

        tempDescargaComp1:
          r["Temp. Descarga Compresor 1"] ??
          r["Temp. Descarga Comp 1"] ??
          r["Temp Descarga Compresor 1"],

        porcentajeCargaComp1:
          r["Porcentaje Carga Comp 1"] ??
          r["Porcentaje Carga Compresor 1"] ??
          r["Porc Carga C1"] ??
          r["Carga Comp 1"],

        sobrecalentamientoComp1:
          r["Sobrecalentamiento Comp 1"] ??
          r["Sobrecalentamiento Cmp 1"],

        encendidoComp1: r["Encendido Compresor 1"],
      };
    })
    .filter(Boolean)
);

const mapVictex1comp = (data, idEquipo) =>
sortDescByFecha(
  (data ?? [])
    .map((row, index) => {
      const r = normalizeKeysTrim(row);
      const fecha = formatUTC(r["Fecha"]);
      if (!fecha) return null;

      return {
        id: index + 1,
        numeroEquipo: r["Número de Equipo"] || idEquipo,
        fecha,

        tempProcesoEntrada: r["Temp. Proceso Entrada"],
        tempProcesoSalida:  r["Temp. Proceso Salida"],
        tempDescarga:       r["Temp. Descarga"],
        tempAmbiente:       r["Temp. Ambiente"],
        presionSuccion:     r["Presion Succion"],
        presionDescarga:    r["Presion Descarga"],

        porcentajeCargaComp1:
          r["Porcentaje Carga Comp 1"] ??
          r["Porcentaje Carga Compresor 1"] ??
          r["Porc Carga"] ??
          r["Carga Comp 1"],

        condicionActual: r["Condición Actual"],
      };
    })
    .filter(Boolean)
);  

const mapFSCV31Comp = (data, idEquipo) =>
  sortDescByFecha(
    (data ?? [])
      .map((row, index) => {
        const r = normalizeKeysTrim(row);
        const fecha = formatUTC(r["Fecha"]);
        if (!fecha) return null;

        return {
          id: index + 1,
          numeroEquipo: r["Número de Equipo"] || idEquipo,
          fecha,

          tempEvapSalida:          r["Temp Evaporador Salida"],
          tempEvapEntrada:         r["Temp Evaporador Entrada"],
          presionSuccionComp1:     r["Presion Succión Comp 1"],
          presionDescargaComp1:    r["Presion Descarga Comp 1"],
          sobrecalentamientoComp1: r["Sobrecalentamiento Comp 1"],
          tempSuccionComp1:        r["Temp Succion Comp 1"],

          encendidoComp1:
            r["Encendido Comp 1"],

          porcentajeCargaComp1:
            r["Porcentaje Carga Comp 1"] ??
            r["Porcentaje Carga Compresor 1"] ??
            r["Porc Carga"] ??
            r["Carga Comp 1"],
        };
      })
      .filter(Boolean)
  );

const mapFSC1Comp = (data, idEquipo) =>
  sortDescByFecha(
    (data ?? [])
      .map((row, index) => {
        const r = normalizeKeysTrim(row);
        const fecha = formatUTC(r["Fecha"]);
        if (!fecha) return null;

        return {
          id: index + 1,
          numeroEquipo: r["Número de Equipo"] || idEquipo,
          fecha,

          tempEvapSalida:     r["Temp Evaporador Salida"],
          tempDescarga:       r["Temp Descarga"],
          presionSuccion:     r["Presion Succión"],
          presionDescarga:    r["Presion Descarga"],
          sobrecalentamiento: r["Sobrecalentamiento"],
          tempSuccion:        r["Temp Succion"],
          encendidoComp1: r["Encendido Compresor 1"],
        };
      })
      .filter(Boolean)
  );

const mapFSCV21Comp = (data, idEquipo) =>
  sortDescByFecha(
    (data ?? [])
      .map((row, index) => {
        const r = normalizeKeysTrim(row);
        const fecha = formatUTC(r["Fecha"]);
        if (!fecha) return null;

        return {
          id: index + 1,
          numeroEquipo: r["Número de Equipo"] || idEquipo,
          fecha,

          tempEvapSalida:     r["Temp Evaporador Salida"],
          tempDescarga:       r["Temp Descarga"],
          presionSuccion:     r["Presion Succión"],
          presionDescarga:    r["Presion Descarga"],
          sobrecalentamiento: r["Sobrecalentamiento"],
          tempSuccion:        r["Temp Succion"],
          encendidoComp1:     r["Encendido Compresor 1"],
        };
      })
      .filter(Boolean)
  );

// ✅ Export “mapas” por tipo (para usarlo directo en dashboard.jsx)
export const DASH_MAPPERS = {
  optichiller2comp: mapOptichiller2Comp,
  centrifuga: mapCentrifuga,
  cotherm2comp: mapCoTherm2Comp,
  cotherm4comp: mapCoTherm4Comp,
  cotherm4comp2cc: mapCoTherm4Comp2cc,
  ezchiller2compct6: mapEzchiller2Compct6,
  fsc: mapFSC,
  fsc_1comp: mapFSC1Comp,
  fsc_unico: mapFSCUNICO,
  fsc_v2_1comp: mapFSCV21Comp,
  fsc_v3: mapFSCV3,
  fsc_v3_1comp: mapFSCV31Comp,
  licuador1comp: mapLicuador1Comp,
  optichiller_ct6: mapOptichillerct6,
  optichiller1comp: mapOptichiller1Comp,
  optichiller1comp_ct6: mapOptichiller1Compct6,
  victex1comp: mapVictex1comp,
};